module.exports = __webpack_public_path__ + "static/media/Uday-Shankar.63287c24.png";